module.exports = __webpack_public_path__ + "officialStatic/img/product-sw.5851d82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-sw.png
// module id = Apcf
// module chunks = 0